import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import parser from 'html-react-parser'

export default function ContentBlocks8({data}) {
    const {contentBlocks8Block1Text, contentBlocks8Block1Title, contentBlocks8Block2SmallText, contentBlocks8Block2Text, contentBlocks8Block2Title, contentBlocks8Block3Text, contentBlocks8Block3Title, contentBlocks8Block4Text, contentBlocks8Block4Title, contentBlocks8Subtitle, contentBlocks8Title} = data
    return (
        <div className='donate-ways-wrap light-grey-bg'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center '>
                        <figure className='donate-heart-icon'>
                            <StaticImage src='../../../images/heart-icon.png' alt='image' />
                        </figure>
                        <h2 className='heading-level-2 blue-color'>{contentBlocks8Title && parser(contentBlocks8Title)}</h2>
                        <p>{contentBlocks8Subtitle && parser(contentBlocks8Subtitle)}</p>
                    </div>
                </div>
                <div className='row ways-row-sec'>
                    <div className='col-md-4 d-way-col'>
                        <div className='give-ways-col d-green-bx'>
                            <div className='heading-level-3'>{contentBlocks8Block1Title && parser(contentBlocks8Block1Title)}</div>
                            <p>{contentBlocks8Block1Text && parser(contentBlocks8Block1Text)}</p>
                        </div>
                    </div>
                    <div className='col-md-8 d-way-col'>
                        <div className='give-ways-col d-white-bx stock-sec'>
                            <div className='heading-level-3'>{contentBlocks8Block2Title && parser(contentBlocks8Block2Title)}</div>
                            <p>{contentBlocks8Block2Text && parser(contentBlocks8Block2Text)}</p>
                            <div className='small-font-text'>
                                <p>{contentBlocks8Block2SmallText && parser(contentBlocks8Block2SmallText)}</p>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-6 d-way-col'>
                        <div className='give-ways-col d-white-bx'>
                            <div className='heading-level-3'>{contentBlocks8Block3Title && parser(contentBlocks8Block3Title)}</div>
                            <p>{contentBlocks8Block3Text && parser(contentBlocks8Block3Text)}</p>
                        </div>
                    </div>

                    <div className='col-md-6 d-way-col'>
                        <div className='give-ways-col d-green-bx'>
                            <div className='heading-level-3'>{contentBlocks8Block4Title && parser(contentBlocks8Block4Title)}</div>
                            {contentBlocks8Block4Text && parser(contentBlocks8Block4Text)}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
